export default __webpack_public_path__ + "static/media/icon_search.1c2635ca.svg";